import { useMemo } from 'react';
import { AnimatePresence, motion } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';

import MessagesList from './components/MessagesList/MessagesList';
import defaultBackground from './assets/images/bg.png';
import { Advt } from './components/Advt/Advt';

function App() {
  const {
    currentState,
    isVisible,
    showedMessages,
    setDelay,
    currentMessageRef,
    delay,
  } = useCarousel();

  const { bg, bgColor, authorFontSize, msgFontSize, speed, scrollTextMsg } =
    useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg]);

  return (
    <div
      className="app-wrapper"
      style={{
        background,
        '--speed': `${speed}ms`,
        '--speedExit': `${(speed * 2) / 3}ms`,
        '--speedExitDelay': `${speed / 3}ms`,
      }}
    >
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <div className="message-wrapper">
            <motion.div
              initial={{ x: '-100%' }}
              animate={{ x: 0 }}
              transition={{ duration: 1 }}
              exit={{
                x: '-100%',
                transition: {
                  delay: 1,
                  duration: 0.5,
                },
              }}
              className="bgMotion"
            />

            <Advt />

            <MessagesList
              key={currentState}
              messages={showedMessages}
              setDelay={setDelay}
              currentMessageRef={currentMessageRef}
              authorFontSize={authorFontSize}
              msgFontSize={msgFontSize}
              speed={speed}
              isScrollTextMsg={scrollTextMsg === '1'}
            />
          </div>
        )}
      </AnimatePresence>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
